<div
  class="tw-col-span-full tw-my-3 tw-flex tw-items-start tw-gap-3 tw-self-stretch tw-rounded-lg tw-border-0 tw-border-l-4 tw-border-solid tw-pr-4 tw-text-xs sm:tw-col-span-8 md:tw-col-start-2 lg:tw-col-span-10 lg:tw-col-start-2 xl:tw-col-span-8 xl:tw-col-start-3"
  [class]="'tw-bg-' + themeClass() + '-100 tw-text-' + themeClass() + '-800'"
>
  <div class="tw-rounded-l-lg tw-p-3">
    <!-- Icon and title for basic alerts-->
    <div class="tw-flex tw-items-start" [ngClass]="{ 'tw-mb-2': isComplex() }">
      <da-icon
        [icon]="icon()"
        type="solid"
        [solidSize]="16"
        class="tw-h-4 tw-w-4"
        [attr.alt]="theme()"
      ></da-icon>
      <span
        class="tw-ml-2"
        [ngClass]="{
          'tw-font-semibold tw-text-{{themeClass()}}-900': hasTitleClass(),
        }"
        >{{ config().title }}</span
      >
    </div>
    <!-- Adding Subtitle, lists, and buttons -->
    @if (isComplex()) {
      <div class="tw-ml-6 tw-flex tw-flex-col">
        @if (hasSubtitle()) {
          <span
            class="tw-text-xs tw-font-semibold tw-text-{{ themeClass() }}-900"
            >{{ config().subTitle }}</span
          >
        }

        <ul class="tw-ml-6 tw-mt-1 tw-list-disc tw-leading-6">
          @for (item of config().items; track item) {
            <li>
              @if (!!item.fragment) {
                <a [routerLink]="['./']" [fragment]="item.fragment">
                  {{ item.text }}
                </a>
              } @else {
                {{ item.text }}
              }
            </li>
          }
        </ul>
        @if (!!config().buttons && config().buttons.length > 0) {
          <div class="tw-mt-3 tw-flex tw-items-center tw-gap-4">
            @for (button of config().buttons; track button) {
              <button
                (click)="eventHandler('button', button.id)"
                class="tw-btn-ghost-neutral"
              >
                {{ button.text }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
